import { useSessionStorage } from 'react-use';

/**
 * セッションストレージkey型定義
 */
type SessionStorageKeys = {
  resetPartnerLoginInfo: {
    mailAddress: string;
  };
  resetLoginInfoEdit: {
    currentLoginId: string;
  };
  resetEmail: {
    newEmailAddress: string;
  };
  pointchargeQueryParams: {
    backurl: string;
  };
};

/**
 * 型安全なセッションストレージフック
 */
export const useSessionStorageEx = <K extends keyof SessionStorageKeys>(
  key: K,
  initialValue?: SessionStorageKeys[K]
) => {
  const [value, setValue] = useSessionStorage<
    SessionStorageKeys[K] | undefined
  >(key, initialValue);

  return {
    value,
    setValue,
  };
};
